import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import AppLayout from '../../../../../generic-components/Layout';
import Heading from '../../../../../generic-components/Heading';
import Button from '../../../../../generic-components/Button';
import { VIEWS_MAP } from '../../../../../router/constants';
import { ADD_BILL_TYPES, NAVIGATION_ACTION_MAP } from '../consts';
import { StripActionsList } from '../components/StripActionsList';
import { useStore } from '../../../../../store';
import { trackMixPanel } from '../../../../../services/mixpanel.service';
import { CloseButton, CloseButtonSize } from '../../../../../DesignSystem/LiliCloseButton/CloseButton';

export const AddBill = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const routerHistory = useStore((state) => state.routerHistory);
  const resetAddBillSlice = useStore((state) => state.resetAddBillSlice);

  const handleAction = (type: string) => {
    if (type === ADD_BILL_TYPES.FILE) {
      trackMixPanel('Act bill upload screen', { Action: 'Upload a bill file or take a photo' });
      navigate(NAVIGATION_ACTION_MAP.UPLOAD_FILE);
    } else if (type === ADD_BILL_TYPES.MANUAL) {
      resetAddBillSlice();
      trackMixPanel('Act bill upload screen', { Action: 'Add a bill manually' });
      navigate(NAVIGATION_ACTION_MAP.CREATE_BILL);
    }
  };

  useEffect(() => {
    resetAddBillSlice();
    const originRoute = routerHistory[routerHistory.length - 1];
    if (originRoute) {
      const isFromHub = originRoute.includes(VIEWS_MAP.BILLS.BASE);
      trackMixPanel(
        'View bill upload screen',
        {
          Origin: isFromHub ? 'bill pay hub' : 'send money menu',
        },
      );
    } else {
      trackMixPanel(
        'View bill upload screen',
        {
          Origin: 'send money menu',
        },
      );
    }
  }, []);

  return (
    <AppLayout
      layoutStyle='absolute inset-0 z-[50] bg-bw00 h-screen w-screen flex flex-col items-center justify-center fadeIn overflow-hidden'
      navBarStyle=''
      chatBotStyle='hidden'
    >
      <div className='flex flex-col justify-center items-center'>
        <CloseButton onClick={() => navigate(`/${VIEWS_MAP.BILLS.BASE}`)} className='absolute left-[34px] top-[17px]' id='closeAddBill' size={CloseButtonSize.Large} />
        <Heading title={t('ADD_BILL.TITLE')} className='font-metricR text-[28px] text-bw08 mb-[4px]' />
        <Heading title={t('ADD_BILL.SUB_TITLE')} className='font-metricR text-[16px] text-bw07 mb-[16px]' />
        <StripActionsList onStripClick={handleAction} />
        <Button onClick={() => navigate(`/${VIEWS_MAP.BILLS.BASE}`)} title={t('UPLOAD_BILL.CANCEL_UPLOAD')} className='font-metricR text-bw08 text-[18px] mt-[24px]' id='cancelAddBill' />
      </div>
    </AppLayout>
  );
};
